<div class="settings-section">
  <app-button-single-line-arrow
    *ngFor="let iMenuItem of settingItems"
    (click)="contextClick(iMenuItem.action)"
  >
    {{ iMenuItem.name }}
  </app-button-single-line-arrow>
</div>
